// @flow

import { setProps } from '../props';

import fetchOrder from '../Services/fetchOrder';
import fetchProcurementItems from './fetchProcurementItems';

import fetchServiceTypes from '../../../Core/Services/fetchServiceTypes';
import fetchUsers from '../../../Core/Services/fetchUsers';
import fetchSuppliers from '../../../Core/Services/fetchSuppliers';

export default (props: any) => async (dispatch: Function) => {

  setProps(props);

  dispatch(fetchOrder());

  dispatch(fetchServiceTypes());
  dispatch(fetchUsers());
  dispatch(fetchSuppliers());
  
  // Fetch procurement items for this order
  const orderId = props.match.params.id;
  if (orderId) {
    dispatch(fetchProcurementItems(orderId));
  }

}